import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Outlet } from 'react-router';
import { setAppMode } from '@store/global/slice';
import { selectAppMode } from '@store/global/selectors';
import { AppModeEnum } from '@project-types/enums';
import LoadingApp from 'components/base-elements/loading/LoadingApp';
import ErrorApp from 'components/base-elements/error/ErrorApp';
import LoginApp from '@layouts/login-app/LoginApp';



const AppLogic = () => {

	const appMode = useSelector(selectAppMode);
	const dispatch = useDispatch();
	const changeAppMode = (mode: AppModeEnum) => dispatch(setAppMode(mode));


	useEffect(() => {
		if (appMode === AppModeEnum.initDataStart) {
			changeAppMode(AppModeEnum.initDataSuccess);
			return;
		}
	}, [ appMode ]);


	if (appMode === AppModeEnum.authFailed ||
		appMode === AppModeEnum.initDataFailed ||
		appMode === AppModeEnum.appFailed ||
		!appMode) return (
			<ErrorApp />
	);

	if (appMode === AppModeEnum.authStart) return (
		<LoginApp />
	);

	/*
	if (appMode === AppModeEnum.initDataStart) return (
		<InitDataApp />
	);
	*/

	if (appMode === AppModeEnum.appSuccess) return (
		<Outlet />
	);

	return (
		<LoadingApp />
	);
};

export default AppLogic;